import { render, staticRenderFns } from "./DropdownQuestion.vue?vue&type=template&id=648a48ab&"
import script from "./DropdownQuestion.vue?vue&type=script&lang=ts&"
export * from "./DropdownQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648a48ab')) {
      api.createRecord('648a48ab', component.options)
    } else {
      api.reload('648a48ab', component.options)
    }
    module.hot.accept("./DropdownQuestion.vue?vue&type=template&id=648a48ab&", function () {
      api.rerender('648a48ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountApplication/accountApplicationForm/typesOfQuestion/DropdownQuestion.vue"
export default component.exports